import { type Infer, nullable, object, string } from "superstruct";

import { BriefBlocksSchema } from "@mpa/platform/brief/schema/index";

import { isoDate } from "../scalar_types/isoDate.js";

export const BriefSerializedSchema = object({
    id: string(),
    createdAt: nullable(isoDate),
    blocks: BriefBlocksSchema,
});

export type BriefSerialized = Infer<typeof BriefSerializedSchema>;
